import Swiper from 'swiper'

/**
 * Banner element that responds on the scrolling of the document.
 * @extends	HTMLElement
 */
customElements.define(
    'swiper-slider',
    class SwiperSliderElement extends HTMLElement {
        constructor() {
            super()

            this._mainSlider = null
            this._thumbnailsSlider = null
        }

        /**
         * Gets the .swiper element from the children.
         *
         * @property
         * @returns {HTMLElement}
         */
        get mainSlider() {
            return this.querySelector('.swiper-slider-main .swiper')
        }

        /**
         * Gets the .swiper--thumbnails element
         *
         * @property
         * @returns {HTMLElement}
         */
        get thumbnailsSlider() {
            return this.querySelector('.swiper-slider-thumbnails .swiper')
        }

        /**
         * Gets and sets the thumbnailBreakpoints slider.
         */
        get thumbnailsSettings() {
            try {
                return JSON.parse(this.getAttribute('thumbnail-settings'))
            } catch (error) {
                return {}
            }
        }

        set thumbnailsSettings(value) {
            if (typeof value === 'object') {
                this.setAttribute('thumbnail-settings', JSON.stringify(value))
            }
        }

        /**
         * Starts up the thumbnail slider.
         *
         * @returns {SwiperSliderElement}
         */
        initThumbnailsSlider() {
            const slider = this.thumbnailsSlider

            if (slider === null) {
                return
            }

            const defaultSettings = {
                loop: true,
                spaceBetween: 10,
                slidesPerView: 2,
                freeMode: true,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: slider.parentElement.querySelector(
                        '.swiper-slider-button-next'
                    ),
                    prevEl: slider.parentElement.querySelector(
                        '.swiper-slider-button-prev'
                    ),
                },
                breakpoints: {
                    320: {
                        slidesPerView: 3,
                    },
                    800: {
                        slidesPerView: 5,
                    },
                },
            }

            const settings = Object.assign(
                defaultSettings,
                this.thumbnailsSettings
            )

            this._thumbnailsSlider = new Swiper(slider, settings)
            return this
        }

        /**
         * Starts up the main slider.
         *
         * @returns {SwiperSliderElement}
         */
        initMainSlider() {
            const slider = this.mainSlider

            if (slider === null) {
                return
            }

            const settings = {
                loop: true,
                speed: 500,
                navigation: {
                    nextEl: slider.parentElement.querySelector(
                        '.swiper-slider-button-next'
                    ),
                    prevEl: slider.parentElement.querySelector(
                        '.swiper-slider-button-prev'
                    ),
                },
            }

            /**
             * If there is a thumbnail slider, then assign the slider to the thumbnail settings.
             */
            if (this._thumbnailsSlider !== null) {
                settings.thumbs = {
                    swiper: this._thumbnailsSlider,
                }
            }

            this._mainSlider = new Swiper(slider, settings)

            /**
             * Dispatch an event whenever a slide is clicked.
             */
            this._mainSlider.on('click', swiper => {
                const slide = swiper.clickedSlide
                const index = Number(slide.dataset.swiperSlideIndex)
                this.dispatchEvent(
                    new CustomEvent('slideclicked', {
                        detail: {
                            slide,
                            index,
                        },
                    })
                )
            })
            return this
        }

        connectedCallback() {
            this.initThumbnailsSlider().initMainSlider()
        }

        disconnectedCallback() {
            if (this._mainSlider !== null) {
                this._mainSlider.destroy()
            }

            if (this._thumbnailsSlider !== null) {
                this._thumbnailsSlider.destroy()
            }
        }

        slideTo(index) {
            this._mainSlider.slideTo(index, 0)
        }
    }
)



// WEBPACK FOOTER //
// ./scripts/web-components/swiper-slider/index.js